import * as React from "react";

/**
 * Delays rendering of its children by a specified threshold.
 * Useful for preventing "flickering" of loading states on fast connections.
 */
export function Deferred({
  children,
  delay = 250,
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!shouldRender) {
    return null;
  }

  return <>{children}</>;
}
